import React, { Component } from 'react';
import { connect } from 'react-redux';

import closeIcon from './../assets/close-icon.png';
import { getTranslatedString } from 'helpers/i18n';

class Header extends Component {
  render() {
    return (
      <div className="sc-header">
        <img className="sc-header--img" src={this.props.imageUrl} alt="" />
        <div className="sc-header--team-name">
          <div>{this.props.teamName}</div>
          {this.props.shouldShowChatResponseTime && (
            <div className="sc-header--small">
              {getTranslatedString('tenantPortal.chat.usuallyReplies')}
            </div>
          )}
        </div>
        <div className="sc-header--close-button" onClick={this.props.onClose}>
          <img src={closeIcon} alt="" />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    shouldShowChatResponseTime: state.userTypes.userPreferences.enable_chat_response_time,
  };
};

export default connect(mapStateToProps)(Header);
